import React, { useContext, useEffect } from "react";
import Form from "../../../../../assets/Style/Form.module.css";
import acm from "../AddCarModal.module.css";
import cpf from "./ClientPriceForm.module.css";
import { AppContext } from "../../../../../providers/appProvider";
import { INSPECTION_WEBSITE_ID } from "../../../../../utils/constans";
import { baseFileURL } from '../../../../../Api';
import { useTranslation } from 'react-i18next';

const ClientPriceForm = ({ newCar, setNewCar, isAdd, prices }) => {
  const { t } = useTranslation();
  const { appState, app } = useContext(AppContext);

  var clientPrice = prices.clientPrice;
  var percent = prices.clientPercent;

  useEffect(() => {
    if(baseFileURL == 'https://finance.automoby.ge') {
      setNewCar((prevState) => ({
        ...prevState,
        client_price_insurance: newCar.client_price_insurance == 0 ? 0 : newCar.client_price_insurance,
        saler_price_insurance: newCar.saler_price_insurance == 0 ? 0 : Math.max(newCar.client_price_insurance - 50, 0),
        saler_price_transfer_fee: 30,
        client_price_transfer_fee: 30 
      }));
    } else {
      setNewCar((prevState) => ({
        ...prevState,
        client_price_insurance: newCar.client_price_insurance == 0 ? 0 : newCar.client_price_insurance,
        saler_price_insurance: newCar.saler_price_insurance == 0 ? 0 : Math.max(newCar.client_price_insurance - 50, 0),
        saler_price_transfer_fee: newCar.saler_price_transfer_fee == 0 ? 0 : Math.max(newCar.client_price_transfer_fee - 60, 0),
      }));
    }
  }, [setNewCar]);

  useEffect(() => {
    if (newCar.insurance === 0 || newCar.insurance === 3) {

      let newState = {
        ...newCar, 
        client_price_insurance: 0,
        saler_price_insurance: 0,
      };
      setNewCar(newState);
 
    }else {  
      /*
      let updatedInsurancePriceClient = 0;
    
      if(baseFileURL == 'https://finance.automoby.ge') {
        updatedInsurancePriceClient = Math.max(Math.ceil(newCar.client_price_car * 0.01), 50);
      } else {
        updatedInsurancePriceClient = Math.max(Math.ceil(newCar.client_price_car * 0.005), 50);
      } 
      
      let newState = {
        ...newCar, 
        client_price_insurance: updatedInsurancePriceClient,
        saler_price_insurance: Math.max(updatedInsurancePriceClient - 50, 0),
      };
      setNewCar(newState);
      */
  

    }

  }, [newCar.insurance, setNewCar]);


  function convertClientToSaler(inputString) {
    if (inputString.startsWith("client_")) {
      return inputString.replace("client_", "saler_");
    } else {
      return inputString;
    }
  }

  const handleClientPriceDealerChange = (event) => {
    let val = convertToInt(event.target.value);
    let newState = {
      ...newCar,
      client_price_dealer: val,
      saler_price_dealer: val,
      car_price_dealer: val,
    };
    setNewCar(newState);
  }

  const handleChangeCarPrice = (event) => {

    let val = convertToInt(event.target.value);
    let clientTransferFee = 0
    let salerTransferFee = 0;
   
  

    /*

      if (newCar.dealer_id > 9999  ) {
        clientTransferFee = Math.max(Math.ceil(val * 0.0015), 15);
        salerTransferFee = Math.max(Math.ceil(val * 0.0015), 15);
      } else {
        clientTransferFee = Math.max(Math.ceil(val * 0.0015), 60);
        salerTransferFee = Math.max(Math.ceil(val * 0.0015), 60);
      }

    */


    if (newCar.dealer_id > 0 && (newCar.website_id === 1 || newCar.website_id === 2 || newCar.website_id === 3 || newCar.website_id === 24 )) {
        clientTransferFee = baseFileURL == 'https://finance.automoby.ge' ? 30 : Math.max(Math.ceil(val * 0.0015), 15 ) ;
        salerTransferFee = baseFileURL == 'https://finance.automoby.ge' ? 30 : Math.max(Math.ceil(val * 0.0015), 15 ) ;
    } else { 
        clientTransferFee = baseFileURL == 'https://finance.automoby.ge' ? 30 : Math.max(Math.ceil(val * 0.0015), 60) ;
        salerTransferFee = baseFileURL == 'https://finance.automoby.ge' ? 30 : Math.max(Math.ceil(val * 0.0015), 60) ;
    }
    
        

         
   
    let updatedInsurance = newCar.insurance;
    let updatedClientInsurancePrice = 0;
    let updatedSalerInsurancePrice = 0;

    if (val >= 20000) {
      updatedInsurance = 1;
    } 
    
    if (updatedInsurance == 1) {
      if(baseFileURL == 'https://finance.automoby.ge') {
        updatedClientInsurancePrice = Math.max(Math.ceil(val * 0.01), 50);
        updatedSalerInsurancePrice = Math.max(Math.ceil(val * 0.005), 50);
      } else {
        updatedClientInsurancePrice = val <= 30000
          ? Math.max(Math.ceil(val * 0.005), 50)
          : Math.ceil(val * 0.01);
        updatedSalerInsurancePrice = Math.max(Math.ceil(val * 0.005), 50);
      }
    }

    let newState = {
      ...newCar,
      client_price_transfer_fee: baseFileURL == 'https://finance.automoby.ge' ? 30 : clientTransferFee,
      saler_price_transfer_fee: baseFileURL == 'https://finance.automoby.ge' ? 30 : Math.max(clientTransferFee - 60, 0),
      car_price_transfer_fee: salerTransferFee,
      insurance: updatedInsurance,
      client_price_insurance: updatedClientInsurancePrice,
      saler_price_insurance: Math.max(updatedSalerInsurancePrice - 50, 0),
      client_price_car: val,
      saler_price_car: val,
    };
    setNewCar(newState);
  };

  const handleChange = (event) => {
    let val = convertToInt(event.target.value);

    setNewCar({
      ...newCar,
      [event.target.name]: val,
      saler_price_fund: event.target.name === "client_price_fund" ? val : newCar.saler_price_fund,
    });
  };

  const handleChangeInsurance = (event) => {
    let val = convertToInt(event.target.value);

    setNewCar({
      ...newCar,
      client_price_insurance: val,
      saler_price_insurance: val,
    });
  };

  const handleBlurInsurance = () => {
    let calculatedInsurance = newCar.client_price_car;
    if(newCar.insurance == 1 && !app.hasPermission('HAS_SUPERUSER_ROLE')) {
      if(baseFileURL == 'https://finance.automoby.ge') {
        calculatedInsurance = Math.max(Math.ceil(newCar.client_price_car * 0.01), 50);
      } else {
        calculatedInsurance = Math.max(Math.ceil(newCar.client_price_car * 0.005), 50);
      }
      if (newCar.client_price_insurance < calculatedInsurance) {
        setNewCar({
          ...newCar,
          client_price_insurance: calculatedInsurance,
          saler_price_insurance: calculatedInsurance,
        });
      }
    } else {
      setNewCar({
        ...newCar,
        client_price_insurance: newCar.client_price_insurance,
        saler_price_insurance: newCar.saler_price_insurance,
      });
    }
  };

  const handleClientPriceInternalChange = (event) => {
    let val = convertToInt(event.target.value);
    let updatedCarPriceInternal = val;

    if (newCar.service !== 3) {
      if (newCar.website_id === 16) {
          if (val < 300) {
              updatedCarPriceInternal = 350;
          } else {
              updatedCarPriceInternal = Math.max(300, val);
          }
      }
    }

    setNewCar({
        ...newCar,
        client_price_internal: updatedCarPriceInternal,
        saler_price_internal: updatedCarPriceInternal,
    });
};

  const handleChangeDocument = (event) => {
    let val = convertToInt(event.target.value);
    setNewCar({
      ...newCar,
      client_price_document: val,
      saler_price_document: val
    });
  };

  const handlePenaltyChange = (event) => {
    let val = convertToInt(event.target.value);
    setNewCar({
      ...newCar,
      client_price_penalty: val,
      saler_price_penalty: val
    });
  };

  const handleAnotherChange = (event) => {
    let val = convertToInt(event.target.value);
    setNewCar({
      ...newCar,
      client_price_another: val,
      saler_price_another: val
    });
  };

  const handleInspectionChange = (event) => {
    let val = convertToInt(event.target.value);
    setNewCar({
      ...newCar,
      client_price_inspection: val,
      saler_price_inspection: val
    });
  };

  const handleDiscountChange = (event) => {
    let val = convertToInt(event.target.value);
    setNewCar({
      ...newCar,
      client_price_discount: val,
      saler_price_discount: val
    });
  };

  function convertToInt(str) {
    const num = parseInt(str, 10);
    return isNaN(num) ? 0 : num;
  }

  const handleKeyPress = (event) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
    const regex = /^[0-9]+$/;

    if (!regex.test(keyValue)) {
      event.preventDefault();
    }
  };

  const handleFocus = (e) => {
    if (e.target.value === "0") {
      setNewCar({
        ...newCar,
        [e.target.name]: "",
      });
    }
  };

  const handleBlur = (e) => {
    if (e.target.value === "") {
      let val = convertToInt(0);
      setNewCar({
        ...newCar,
        [e.target.name]: val,
      });
    }
  };

  const handleToggleChange = () => {
    let updatedInsurance = newCar.insurance;
    if(!newCar.fund_accept) {
      updatedInsurance = 1
    }

    setNewCar({
      ...newCar,
      fund_accept: !newCar.fund_accept,
      insurance: updatedInsurance
    });
  };

  const handleToggleChangeDiscount = () => {
    setNewCar({
      ...newCar,
      discount_accept: !newCar.discount_accept,
    });
  };

  const handleChangePriceFund = (event) => {
    let val = convertToInt(event.target.value);
    setNewCar({
      ...newCar,
      client_price_fund: val,
      saler_price_fund: val,
      car_price_fund: val
    });
  };

  const handleChangePercentFund = (event) => {
    let val = convertToInt(event.target.value);
    setNewCar({
      ...newCar,
      client_percent_fund: val,
      saler_percent_fund: val,
      car_percent_fund:val
    });
  };

  var isDisable = isAdd
    ? !app.hasPermission("CLIENT_PRICE_ADD")
    : !app.hasPermission("CLIENT_PRICE_EDIT");


  const [initialCarPrice] = React.useState(newCar.client_price_car);
  
  if (app.hasPermission("FINANCE_EDIT_IF_CAR_PRICE_0") && initialCarPrice == 0) {
    isDisable = false;
  }

  if (newCar.website_id === INSPECTION_WEBSITE_ID) {
    isDisable = true;
  }

  return (
    <fieldset className={acm.formField}>
      <legend>{t('ClientPrice')} </legend>

      <>
        {" "}
        <div className={cpf.groupPrice}>
          <label className={cpf.leftLabel}>{t('CarPrice')}</label>
          <div className={cpf.rightInput}>
            <div className={Form.priceInput}>
              <div className={Form.priceCurrency}>USD</div>
              <input
                disabled={isDisable}
                type="text"
                onFocus={handleFocus}
                onBlur={handleBlur}
                onKeyPress={handleKeyPress}
                className={Form.input}
                name="client_price_car"
                onChange={handleChangeCarPrice}
                value={newCar.client_price_car}
                min="0"
              />
              <div className={Form.hundred}>.00</div>
            </div>
          </div>
        </div>
        <div className={cpf.groupPrice}>
          <label className={cpf.leftLabel}>{t('ContainerPrice')}</label>
          <div className={cpf.rightInput}>
            <div className={Form.priceInput}>
              <div className={Form.priceCurrency}>USD</div>
              <input
                type="text"
                disabled={isDisable}
                onFocus={handleFocus}
                onBlur={handleBlur}
                onKeyPress={handleKeyPress}
                name="client_price_transport"
                className={Form.input}
                onChange={handleChange}
                value={newCar.client_price_transport}
                min="0"
              />
              <div className={Form.hundred}>.00</div>
            </div>
          </div>
        </div>
        <div className={cpf.groupPrice}>
          <label className={cpf.leftLabel}>{t('InternalTransportation')}</label>
          <div className={cpf.rightInput}>
            <div className={Form.priceInput}>
              <div className={Form.priceCurrency}>USD</div>
              <input
                type="text"
                disabled={isDisable}
                onFocus={handleFocus}
                onBlur={(event) => {handleClientPriceInternalChange(event)}}
                onKeyPress={handleKeyPress}
                name="client_price_internal"
                className={Form.input}
                onChange={(event) => {
                  // Update the raw input value without applying business logic
                  setNewCar({
                    ...newCar,
                    client_price_internal: event.target.value,
                    saler_price_internal: event.target.value,
                  });
                }}
                value={newCar.client_price_internal}
                min="0"
              />
              <div className={Form.hundred}>.00</div>
            </div>
          </div>
        </div>
        <div className={cpf.groupPrice}>
          <label className={cpf.leftLabel}>{t('Procent')}</label>
          <div className={cpf.rightInput}>
            <div className={Form.priceInput}>
              <div className={Form.priceCurrency}>USD</div>
              <input
                type="text"
                disabled={isDisable}
                className={Form.input}
                value={percent}
                min="0"
                readOnly
              />
              <div className={Form.hundred}>.00</div>
            </div>
          </div>
        </div>
        {newCar.dealer_id > 0 && (
          <>
          <div className={cpf.groupPrice}>
            <label className={cpf.leftLabel}>{t('DealerCommissionCar')}</label>
            <div className={cpf.rightInput}>
              <div className={Form.priceInput}>
                <div className={Form.priceCurrency}>USD</div>
                <input
                  type="text"
                  disabled={isDisable}
                  onFocus={handleFocus}
                  onBlur={handleBlur}
                  onKeyPress={handleKeyPress}
                  name="client_price_dealer"
                  className={Form.input}
                  onChange={handleClientPriceDealerChange}
                  value={newCar.client_price_dealer}
                  min="0"
                />
                <div className={Form.hundred}>.00</div>
              </div>
            </div>
          </div>
          <div className={cpf.groupPrice}>
            <label className={cpf.leftLabel}>{t('DealerCommissionTransport')}</label>
            <div className={cpf.rightInput}>
              <div className={Form.priceInput}>
                <div className={Form.priceCurrency}>USD</div>
                <input
                  type="text"
                  disabled={isDisable}
                  onFocus={handleFocus}
                  onBlur={handleBlur}
                  onKeyPress={handleKeyPress}
                  name="client_price_dealer_transport"
                  className={Form.input}
                  onChange={(event) => {
                    let val = convertToInt(event.target.value);
                    setNewCar({
                      ...newCar, 
                      client_price_dealer_transport: val,
                      saler_price_dealer_transport: val,
                      car_price_dealer_transport: val,
                    });
                  }}
                  value={newCar.client_price_dealer_transport}
                  min="0"
                />
                <div className={Form.hundred}>.00</div>
              </div>
            </div>
          </div>
          </>
        )}
        <div className={cpf.groupPrice}>
          <label className={cpf.leftLabel}>{t('DocumentPrice')}</label>
          <div className={cpf.rightInput}>
            <div className={Form.priceInput}>
              <div className={Form.priceCurrency}>USD</div>
              <input
                type="text"
                disabled={isDisable}
                onFocus={handleFocus}
                onBlur={handleBlur}
                onKeyPress={handleKeyPress}
                name="client_price_document"
                className={Form.input}
                onChange={handleChangeDocument}
                value={newCar.client_price_document}
                min="0"
              />
              <div className={Form.hundred}>.00</div>
            </div>
          </div>
        </div>
        <div className={cpf.groupPrice}>
        <label className={cpf.leftLabel}>{t('Insurance')}</label>
        <div className={cpf.rightInput}>
          <div className={Form.priceInput}>
            <div className={Form.priceCurrency}>USD </div>
            <input
              type="text"
              onFocus={handleFocus}
              onBlur={handleBlurInsurance}
              onKeyPress={handleKeyPress}
              name="client_price_insurance"
              className={Form.input}
              onChange={handleChangeInsurance}
              value={newCar.client_price_insurance}
              disabled={newCar.insurance === 0} 
            />
            <div className={Form.hundred}>.00</div>
          </div>
        </div>
      </div>
        <div className={cpf.groupPrice}>
          <label className={cpf.leftLabel}>{t('Penalty')}</label>
          <div className={cpf.rightInput}>
            <div className={Form.priceInput}>
              <div className={Form.priceCurrency}>USD</div>
              <input
                type="text"
                disabled={isDisable}
                onFocus={handleFocus}
                onBlur={handleBlur}
                onKeyPress={handleKeyPress}
                name="client_price_penalty"
                className={Form.input}
                onChange={handlePenaltyChange}
                value={newCar.client_price_penalty}
                min="0"
              />
              <div className={Form.hundred}>.00</div>
            </div>
          </div>
        </div>
 
            <div className={cpf.groupPrice}>
              <label className={cpf.leftLabel}>{t('TransferFee')}</label>
              <div className={cpf.rightInput}>
                <div className={Form.priceInput}>
                  <div className={Form.priceCurrency}>USD</div>
                  <input
                    type="text"
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                    onKeyPress={handleKeyPress}
                    name="client_price_transfer_fee"
                    className={Form.input}
                    onChange={handleChange}
                    value={ newCar.client_price_transfer_fee }   
                    disabled={!app.hasPermission("CLIENT_PRICE_TRANSFER_FEE_CHANGE") || isDisable}
 
                  />
                  <div className={Form.hundred}>.00</div>
                </div>
              </div>
            </div>
           
        
        <div className={cpf.groupPrice}>
        <label className={cpf.leftLabel}>{t('Inspection')}</label>
        <div className={cpf.rightInput}>
          <div className={Form.priceInput}>
            <div className={Form.priceCurrency}>USD</div>
            <input
              type="text"
              disabled={
                isAdd
                  ? !app.hasPermission("CLIENT_PRICE_ADD")
                  : !app.hasPermission("CLIENT_PRICE_EDIT")
              }
              onFocus={handleFocus}
              onBlur={handleBlur}
              onKeyPress={handleKeyPress}
              name="client_price_inspection"
              className={Form.input}
              onChange={handleInspectionChange}
              value={newCar.client_price_inspection}
              min="0"
            />
            <div className={Form.hundred}>.00</div>
          </div>
        </div>
      </div>
        <div className={cpf.groupPrice}>
          <label className={cpf.leftLabel}>{t('Other')}</label>
          <div className={cpf.rightInput}>
            <div className={Form.priceInput}>
              <div className={Form.priceCurrency}>USD</div>
              <input
                type="text"
                disabled={isDisable}
                onFocus={handleFocus}
                onBlur={handleBlur}
                onKeyPress={handleKeyPress}
                name="client_price_another"
                className={Form.input}
                onChange={handleAnotherChange}
                value={newCar.client_price_another}
                min="0"
              />
              <div className={Form.hundred}>.00</div>
            </div>
          </div>
        </div>
        <div className={cpf.groupPrice}>
          <label className={cpf.leftLabel}>{t('RequestedAmount')}</label>
          <div className={cpf.rightInput}>
            <div className={Form.priceInput}>
              <div className={Form.priceCurrency}>USD</div>
              <input
                type="text"
                disabled={
                  !app.hasPermission("FUND_PRICE_EDIT") ||
                  newCar.fund_accept ||
                  isDisable
                }
                onFocus={handleFocus}
                onBlur={handleBlur}
                onKeyPress={handleKeyPress}
                name="client_price_fund"
                className={Form.input}
                onChange={handleChangePriceFund}
                value={newCar.client_price_fund}
                min="0"
              />
              <div className={Form.hundred}>.00</div>
            </div>
          </div>
        </div>


        <div className={cpf.groupPrice}>
          <label className={cpf.leftLabel}>{t('RequestProcent')}</label>
          <div className={cpf.rightInput}>
            <div className={Form.priceInput}>
              <div className={Form.priceCurrency}>%</div>
              <input
                type="text"
                disabled={!app.hasPermission("FUND_PERCENT_EDIT") || isDisable}
                onFocus={handleFocus}
                onBlur={handleBlur}
                onKeyPress={handleKeyPress}
                name="client_percent_fund"
                className={Form.input}
                onChange={handleChangePercentFund}
                max="100"
                value={newCar.client_percent_fund}
                min="0"
              />
              <div className={Form.hundred}>.00</div>
            </div>
          </div>
        </div>
        <div className={cpf.groupPrice}>
          <label className={cpf.leftLabel}>{t('AgreementОnРequest')}</label>
          <div className={cpf.rightInput}>
            <div className={cpf.toggleSwitch}>
              <input
                type="checkbox"
                name="fund_accept"
                className={Form.input2}
                checked={newCar.fund_accept}
                onChange={handleToggleChange}
                disabled={!app.hasPermission("FUND_ACCEPT_EDIT") || isDisable}
              />
            </div>
          </div>
        </div>



        <div className={cpf.groupPrice}>
          <label className={cpf.leftLabel}>{t('Discount')}</label>
          <div className={cpf.rightInput}>
            <div className={Form.priceInput}>
              <div className={Form.priceCurrency}>USD</div>
              <input
                type="text"
                disabled={!app.hasPermission("PRICE_DISCOUNT_EDIT") || isDisable}
                onFocus={handleFocus}
                onBlur={handleBlur}
                onKeyPress={handleKeyPress}
                name="client_price_discount"
                className={Form.input}
                onChange={handleDiscountChange}
                max="100"
                value={newCar.client_price_discount}
                min="0"
              />
              <div className={Form.hundred}>.00</div>
            </div>
          </div>
        </div>

        <div className={cpf.groupPrice}>
          <label className={cpf.leftLabel}>{t('AgreementОnDiscount')}</label>
          <div className={cpf.rightInput}>
            <div className={cpf.toggleSwitch}>
              <input
                type="checkbox"
                name="discount_accept" 
                className={Form.input2}
                checked={newCar.discount_accept}
                onChange={handleToggleChangeDiscount}
                disabled={!app.hasPermission("DISCOUNT_ACCEPT_EDIT") || isDisable}
              />
            </div>
          </div>
        </div>



      </>

 

      <div className={cpf.TotalPrice}>
        <div className={cpf.paramTotal}></div>
        <div className={cpf.priceCredit}>
          <span className={cpf.curr}>USD</span>
          {clientPrice}
        </div>
      </div>
    </fieldset>
  );
};

export default ClientPriceForm;
